module.exports = __webpack_public_path__ + "static/media/cross-icon.adcb575b.svg";